require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-130-my-tasks.json") })
        }
      }, "path---article-130-my-tasks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-130-my-tasks!./.cache/json/article-130-my-tasks.json
// module id = 484
// module chunks = 231608221292675